export default `
  --disclaimer-background: #E5E5E5;
  --disclaimer-border-radius: 10px;
  --disclaimer-padding: 10px 15px;
  --disclaimer-logo-brightness: 91%;
`;
